/* eslint-disable @typescript-eslint/no-explicit-any */
import { Download, Edit3, Loader2 } from 'lucide-react';
import { Dispatch, FC, SetStateAction } from 'react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import useGetReports from '@/hooks/useGetReports';
import useGetUserReports from '@/hooks/useGetUserReports';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from './ui/table';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

interface Props {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  client: any;
}

const UserReportsModal: FC<Props> = ({ isOpen, setIsOpen, client }) => {
  const navigate = useNavigate();
  const { data: userReports } = useGetUserReports(client.accountUserId, isOpen);

  const handleDownload = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Edit3 className="h-5 w-5" />
            User Reports
          </DialogTitle>
        </DialogHeader>
        <Table className="min-w-[780px] w-full">
          <TableHeader>
            <TableRow>
              <TableHead>Property Address</TableHead>
              <TableHead>Date Added</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {(userReports ?? []).map((property) => (
              <TableRow key={property._id}>
                <TableCell className="font-medium">
                  {property.address}
                </TableCell>
                <TableCell>
                  {dayjs(property.createdAt).format('YYYY-MM-DD')}
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    {(property.status || 'Complete') === 'Processing' && (
                      <Loader2 className="h-4 w-4 animate-spin text-primary" />
                    )}
                    {property.status || 'Complete'}
                  </div>
                </TableCell>
                <TableCell className="text-right">
                  <Button
                    variant="outline"
                    size="sm"
                    className="flex items-center self-end"
                    onClick={() =>
                      navigate(`/property-tax-report/${property._id}`)
                    }
                  >
                    Edit Report
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UserReportsModal;
